export default __webpack_public_path__ + "static/media/logo.847c66b4.svg";